import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../dto/data-model-utils.js';
import {
  SerializedData, SerializationContext, DataModelBuilder,
} from '../../../dto/data-model.js';
import { OpenAccessPass } from '../../open-access-pass/open-access-pass.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { AuditLogEntry } from '../audit-log-entry.js';

export class OpenAccessPassCreatedForLegacyBackendEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = 'c53a4344933d46f9aed2e298acec4d50';

  private constructor(
    private readonly pass: OpenAccessPass,
  ) {
    super();
  }

  get $typeId(): string {
    return OpenAccessPassCreatedForLegacyBackendEntry.TYPE_ID;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.pass.businessRef.encode(),
      passId: this.pass.uniqueId,
      orderId: this.pass.orderId,
    };
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.EventOpenAccessPassCreated;
  }

  static create(args: {
    pass: OpenAccessPass,
  }): OpenAccessPassCreatedForLegacyBackendEntry {
    return new OpenAccessPassCreatedForLegacyBackendEntry(
        args.pass,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OpenAccessPassCreatedForLegacyBackendEntry {
    return this.create({
      pass: context.fromData<OpenAccessPass>(MapUtils.getRecord(map, 'pass')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      pass: context.toData(this.pass),
    };
  }

  clone(): this {
    return OpenAccessPassCreatedForLegacyBackendEntry.create({
      pass: cloneData(this.pass),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.pass, this.pass);
  }
}

export class OpenAccessPassCreatedForLegacyBackendEntryBuilder extends DataModelBuilder<OpenAccessPassCreatedForLegacyBackendEntry> {
  build(context: SerializationContext, map: SerializedData): OpenAccessPassCreatedForLegacyBackendEntry {
    return OpenAccessPassCreatedForLegacyBackendEntry.fromMap(context, map);
  }
}
